import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useOnboardingConsultant = (id) => useQuery({ queryKey: [`onboarding-consultant`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/onboarding/consultant/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 5 })

export default useOnboardingConsultant